var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    'background-color':
      _vm.holderForm && _vm.holderForm.options.background_color
        ? _vm.holderForm.options.background_color
        : '#fff',
    padding: '0px',
  })},[_c('div',{staticClass:"webforms-content"},[(!_vm.loading)?_c('div',[(_vm.holderForm)?_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{style:({
            'background-color': '#fff',
            padding: '20px',
          })},[(_vm.holderForm.logo)?_c('img',{style:({
              'max-width': '250px',
              'max-height': '150px',
            }),attrs:{"src":_vm.holderForm.logo}}):_c('div',{style:({
              'font-size': '30px',
              'margin-bottom': '15px',
            })},[_vm._v(" "+_vm._s(_vm.holderForm.name)+" ")])]),(_vm.holderForm.options['introduce_' + _vm.getLang2Letters()])?_c('div',{style:({
            'max-width': '700px',
            margin: '0 auto',
            color: _vm.holderForm.options.font_color,
            'margin-top': '20px',
            'text-align': 'justify',
            'white-space': 'pre-line',
            padding: '20px',
          })},[_vm._v(" "+_vm._s(_vm.holderForm.options["introduce_" + _vm.getLang2Letters()])+" ")]):_vm._e()]):_vm._e(),_c('div',{style:({
          display: 'flex',
          'justify-content': 'center',
          'margin-top': '20px',
        })},[_c('FormPage',{style:({
            'max-width': '700px',
            width: '100%',
          }),attrs:{"client":_vm.client,"form":_vm.form},on:{"getform":_vm.getform}})],1)]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }